import { IStreamData } from "@formant/core/model/IStreamData";
import { StreamType } from "@formant/core/model/StreamType";

export function filterDataByType<T extends StreamType>(
    datas: IStreamData[],
    type: T,
): IStreamData<T>[] {
    return datas.filter(_ => _.type === type) as IStreamData<T>[];
}
